<!--page starts-->
<section class="page-wrapper">
	<div class="ashton-hero-top-clubsponsorship">
		<div class="container">
			<div class="ashton-hero-top-clubsponsorship-detail">
				<h2>SUBSCRIBE AND ENJOY AN EXCLUSIVE EXPERIENCE</h2>
			</div>
		</div>
		<div class="ashton-hero-top-clubsponsorship-overlay"></div>
	</div>
	<div class="ashton-hero-top-clubsponsorship-section cf">
		<div class="container">
			<div class="ashton-hero-top-clubsponsorship-section-detail cf">
				<div class="ashton-clubsponsorship-top-content">
					<p>A Match Sponsorship is a great way to entertain clients, family or friends and enjoy the ambience
						and hospitality of one of Britain’s oldest football clubs. </p>
				</div>
				<div class="ashton-clubsponsorship-bottom">
					<div class="ashton-matchday-detail" *ngFor="let hospital of hospitalityList?.data">
						<div class="ashton-matchday-content" >
							<h2>{{hospital?.title}}</h2>
							<div [innerHTML]="hospital?.description" class="list"></div>

							<!-- <h3>Package for 10 people  includes: </h3>
      	 			   		<ul>
      	 			   			<li>Three course pre match meal with complimentary wine.</li>
      	 			   			<li>Complimentary  match day  programmes.</li>
      	 			   			<li>Pre match managers team talk.</li>
      	 			   			<li>Match programme endorsement .</li>
      	 			   			<li>Reserved seating in main stand.</li>
      	 			   			<li>Bar tab available.</li>
      	 			   		</ul> -->
							<div class="ashton-matchday-detail-inner">
								<div class="ashton-matchday-detail-inner-left" [innerHTML]="hospital?.amount">
									<!-- <h3>Category A match £500.00 plus VAT</h3>
      	 			   				<h3>Category A match £500.00 plus VAT</h3>
      	 			   				<p>(Additional places available pro rata).</p> -->
								</div>
								<div class="ashton-matchday-detail-inner-right">
									<a href="#login-box-{{hospital.hospitality_id}}" class="popup-login">Contact Us</a>
								</div>
							</div>
						</div>
						<div class="ashton-matchday-image " >
							<img [src]="hospital?.image">
						</div>
						
						<div class="login-section forlogin-section matchday  mfp-hide"
							id="login-box-{{hospital.hospitality_id}}">
							<div class="add-popup cf">
								<div class="container">
									<div class="checkout-center-detail-popup">
										<h2>Contact Us</h2>
										<form #hcontactForm="ngForm"
											(ngSubmit)="contactUs(hcontactForm, hospital.hospitality_id)">
											<input type="hidden" id="hospitality_id-{{hospital.hospitality_id}}"
												name="hospitality_id" value="{{hospital.hospitality_id}}">
											<http-message types="success" [data]="hcontactSuccess"
												class="err-msg-block"></http-message>
											<http-message [type]="'error'" [data]="hcontactError" *ngIf="hcontactError"
												class="err-msg-block"></http-message>
											<div class="checkout-center-detail-address-box cf">
												<div class="checkout-address-box half">
													<app-form-field validation="required" name="first_name"
														[(ngModel)]="hcontactRequest.first_name" class="app-group">
														<input appFieldInput type="text" name=""
															placeholder="First Name" class="input-style">
													</app-form-field>
												</div>
												<div class="checkout-address-box half">
													<app-form-field validation="required" name="last_name"
														[(ngModel)]="hcontactRequest.last_name" class="app-group">
														<input appFieldInput type="text" name="" placeholder="last Name"
															class="input-style">
													</app-form-field>
												</div>
												<div class="checkout-address-box full">
													<app-form-field validation="required" name="email"
														[(ngModel)]="hcontactRequest.email" class="app-group">
														<input appFieldInput type="text" name=""
															placeholder="Email Address" class="input-style">
													</app-form-field>
												</div>
												<div class="checkout-address-box full">
													<app-form-field validation="required" name="phone_number"
														[(ngModel)]="hcontactRequest.phone_number" class="app-group">
														<input appFieldInput type="text" name="" placeholder="Phone"
															class="input-style">
													</app-form-field>
												</div>
												<div class="checkout-address-box full">
													<app-form-field validation="required" name="description"
														[(ngModel)]="hcontactRequest.description" class="app-group">
														<textarea appFieldInput class="input-style "
															placeholder="Description"></textarea>
													</app-form-field>
												</div>
												<div class="checkout-address-box-btn">
													<button type="submit">Submit</button>

												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
			<div class="our-charity-detail cf">
				<div class="our-charity-left">
					<h3>OUR CHARITY</h3>
					<p>ASHTON UNITED IN COMMUNITY</p>
					<div class="our-charity-left-btn">
						<a href="https://www.auitc.co.uk/" target="_blank" class="seemore-white">Know More</a>
					</div>
				</div>
				<div class="our-charity-right">
					<img src="assets/images/Bitmap-icon.png" alt="Bitmap-icon">
				</div>
			</div>
		</div>
	</div>
</section><!-- page ends -->